import SeoLandingPage from "../components/SeoLandingPage";

const page = {
  path: "/talentos",
  breadcrumbName: "Aptofy TalentOS™",
  serviceType: "Talent Operating System",
  eyebrow: "Aptofy TalentOS™",
  title: "Aptofy TalentOS™ | Talent Operating System for Hiring at Scale",
  description:
    "Aptofy TalentOS™ is a talent operating system that helps teams source, assess, track, and shortlist candidates with AI-backed scorecards and recruiter workflows.",
  keywords:
    "Aptofy TalentOS, talent operating system, talent OS software, AI talent management platform, talent acquisition OS, recruitment operating system, HR talent OS, candidate pipeline software, Aptofy talent platform",
  h1: "Aptofy TalentOS™ — The Talent Operating System for Modern Hiring",
  intro:
    "Run talent acquisition as an operating system, not a pile of spreadsheets. TalentOS™ brings jobs, candidates, assessments, and recruiter workflows into one platform so your team can hire faster with consistent, role-ready insights.",
  sections: [
    {
      heading: "What Is a Talent Operating System?",
      paragraphs: [
        "A talent operating system (Talent OS) is the system of record and action for how an organization attracts, evaluates, and moves talent. Unlike a basic ATS that only tracks applications, a talent OS connects sourcing, screening, assessments, interviews, and shortlisting into one repeatable workflow.",
        "Aptofy TalentOS™ is built for talent teams that need structure at scale — campus drives, lateral hiring, GCC recruitment, and multi-location pipelines — without losing evaluation quality.",
      ],
    },
    {
      heading: "How Aptofy TalentOS™ Works",
      paragraphs: [
        "Create roles, invite candidates, run assessments, and review structured reports from one recruiter workspace. TalentOS™ acts as your extended TA layer — helping you post jobs, track every candidate, and deliver ready-to-review profiles with scores, video responses, and transcripts.",
      ],
      bullets: [
        "Job and pipeline management",
        "Bulk candidate invites and tracking",
        "Role-aligned talent assessments",
        "AI-backed evaluation scorecards",
        "Recruiter platform as a service",
        "Offer-letter and workflow support",
      ],
    },
    {
      heading: "Key Capabilities",
      bullets: [
        "End-to-end candidate pipeline visibility",
        "Structured screening before human rounds",
        "Proctored assessments inside the same OS",
        "Consistent scoring across batches and locations",
        "Reports hiring managers can act on quickly",
        "Works with Aptofy IntelliHire™ and AutoCert™",
      ],
    },
    {
      heading: "Business Impact",
      paragraphs: [
        "TalentOS™ reduces the operational load of high-volume hiring. Recruiters spend less time chasing status and more time on final selection. Leaders get a clearer view of funnel health, evaluation quality, and time-to-shortlist.",
      ],
      bullets: [
        "Shorter hiring cycles",
        "Lower cost-per-hire",
        "Better pipeline discipline",
        "More consistent role-fit decisions",
      ],
    },
    {
      heading: "Who TalentOS™ Is For",
      bullets: [
        "Enterprise talent acquisition teams",
        "Startups building a hiring engine",
        "GCCs and distributed recruitment teams",
        "Staffing partners managing client pipelines",
        "Campus and high-volume hiring programs",
      ],
    },
  ],
  faqs: [
    {
      question: "Is Aptofy TalentOS™ an ATS?",
      answer:
        "TalentOS™ includes recruiter-platform and ATS-style workflows, but it goes further as a talent operating system — connecting assessments, AI evaluation, and pipeline management in one place.",
    },
    {
      question: "Can TalentOS™ handle bulk hiring?",
      answer:
        "Yes. TalentOS™ is designed for high-volume invites, assessments, and shortlisting without multiplying recruiter hours linearly.",
    },
    {
      question: "How is TalentOS™ different from IntelliHire™?",
      answer:
        "TalentOS™ is the operating layer for talent workflows and pipelines. IntelliHire™ focuses on AI-led intelligent interviewing and scoring. Teams often use them together.",
    },
    {
      question: "How do we start using TalentOS™?",
      answer:
        "Request a demo or start a free trial. We can onboard roles, assessment flows, and recruiter access quickly.",
    },
  ],
  ctaHeading: "Put hiring on an operating system",
  ctaText:
    "See how Aptofy TalentOS™ can help your team source, assess, and shortlist talent with less admin and more consistency.",
};

export default function TalentOsPage() {
  return <SeoLandingPage page={page} />;
}
